import { TimeUnit } from '../types/timeseries-props.js';

const TIME_THRESHOLD_REGEX = /^(\d+)(y|mo|d|h|min|s|ms)$/;

/**
 * Parses a time threshold expression.
 * @param value -
 */
export const parseTimeThreshold = (
  value: string,
): [number, TimeUnit] | undefined => {
  const matched = value.match(TIME_THRESHOLD_REGEX);

  return matched ? [+matched[1], matched[2] as TimeUnit] : undefined;
};

const MULTIPLIERS = {
  y: 31556926000,
  mo: 2629800000,
  d: 86400000,
  h: 3600000,
  min: 60000,
  s: 1000,
  ms: 1,
} as const;

export const convertTimeThreshold = (
  timeThresholdExpr: string,
): number | undefined => {
  const parsedValue = parseTimeThreshold(timeThresholdExpr);
  if (!parsedValue) {
    return undefined;
  }
  const [value, unit] = parsedValue;

  return value * MULTIPLIERS[unit];
};
